import { ReactSelectValue } from 'types/forms';

import SingleChoiceButtons from 'components/DesignSystem/SingleChoiceButtons/SingleChoiceButtons';
import CheckboxCard from 'components/DesignSystem/CheckboxCard/CheckboxCard';
import { BillingServiceName, BillingPrice } from 'services/backend/billing';
import { getOptionPrice } from '../helpers';

interface ReportingOptionsProps {
  numberOfGroups: string;
  reportingGroupsOptions: ReactSelectValue<string>[] | undefined;
  activePrices: BillingPrice[] | undefined;
  setNumberOfGroups: (arg: string) => void;
  reportComplexity: string;
  reportComplexityOptions: ReactSelectValue<string>[] | undefined;
  setReportComplexity: (arg: string) => void;
  reportingOptionsData: {
    ordering: number;
    label: string;
    value: BillingServiceName;
    tooltip: string;
    subtitle: string;
    isSelected: boolean;
    onToggle: () => void;
  }[];
  isLoadingBreakdown: boolean;
}

const ReportingOptionsPanel = ({
  numberOfGroups,
  reportingGroupsOptions,
  activePrices,
  reportComplexity,
  reportComplexityOptions,
  setNumberOfGroups,
  setReportComplexity,
  reportingOptionsData,
  isLoadingBreakdown,
}: ReportingOptionsProps) => {
  return (
    <div className="flex flex-grow flex-col rounded-lg shadow p-8 text-left h-fit gap-4 bg-white">
      <div>
        <p className="font-bold text-2xl">Reporting Complexity</p>
        <p className="text-sm mt-5 mb-2">
          Report Complexity (slide design, amount of information per slide, or
          level of data analysis):
        </p>
        <SingleChoiceButtons
          onSelect={setReportComplexity}
          options={reportComplexityOptions}
          selected={reportComplexity}
        />
        <p className="text-sm mt-5 mb-2">
          Number of Groups/Subgroups to be analyzed/reported on:
        </p>
        <SingleChoiceButtons
          onSelect={setNumberOfGroups}
          options={reportingGroupsOptions}
          selected={numberOfGroups}
        />
      </div>
      <hr className="my-3 border-[#F3F4F6]" />
      <div>
        <p className="font-bold text-2xl">Reporting & Analysis</p>
        <p className="text-gray-500">
          Tell us about your reporting needs and select any deliverables.
        </p>
      </div>
      <div>
        <p className="font-semibold text-lg">Reporting Deliverables</p>
        <p className="text-gray-500">
          Select any reporting deliverables. All are optional.
        </p>
        {reportingOptionsData.map((service) => (
          <CheckboxCard
            key={`quote-tool-survey-design-checkbox-card-${service.ordering}`}
            cardLabel={service.label}
            cardSubtitle={service.subtitle}
            isLoading={isLoadingBreakdown}
            isSelected={service.isSelected}
            onClick={service.onToggle}
            price={getOptionPrice(service.value, activePrices)}
            toolTipText={service.tooltip}
          />
        ))}
      </div>
    </div>
  );
};

export default ReportingOptionsPanel;
